const config = window.__RUNTIME_CONFIG__;

if (!config) {
  throw new Error("Runtime config not loaded");
}

export default {
  ...config
};